import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateReportFormatter, dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AgentCallsLog() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [account, setAccount] = useState("");
  const onAccountChange = useCallback(
    (event) => setAccount(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChanged = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <TextField
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Agent Calls Log Report"
        getUrl={() => "/Reports/Report_Agent_Calls_Log_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Agent: agent,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="ip">
          Ip
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default AgentCallsLog;
